import React, { useCallback, useEffect } from "react";
import { useChangePassword } from "../hooks";
import { AxCard, AxIconWrapper, AxPopover } from "@dynata/axiom3";
import "../../../../scss/account.scss";
import isPasswordCorrect from "../../../../services/validation";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { RapButton, RapInput } from "@dynata/rex-raptor";
import { GENERIC_ERROR } from "../../../../core/utils/baseError";
import { ToastConfig } from "core/widgets/toastConfig.widget";
type Props = {
  userId: number;
};

export const ChangePass: React.FC<Props> = ({ userId }) => {
  const navigate = useNavigate();

  const { changePass } = useChangePassword();

  const handleSubmit = useCallback(
    async (event: React.FormEvent<HTMLFormElement>) => {
      event.preventDefault();
      const formData = Object.fromEntries(new FormData(event.currentTarget));

      const currentPass = formData.currentPass as string;
      const newPass = formData.newPass as string;

      if (currentPass && newPass) {
        const correct = isPasswordCorrect(newPass);
        if (correct.success) {
          changePass.mutate(
            { userId: userId, newPass: newPass, currPass: currentPass },
            {
              onSuccess: () => {
                toast.success("Password updated successfully", ToastConfig);
              },
              onError: () => {
                toast.error(GENERIC_ERROR, ToastConfig);
              },
            },
          );
        } else {
          toast.error(correct.error.message, ToastConfig);
        }
      } else {
        toast.error("Fill in the values", ToastConfig);
      }
    },
    [userId],
  );

  useEffect(() => {
    let time: ReturnType<typeof setTimeout>;
    if (changePass.isSuccess) {
      time = setTimeout(() => {
        navigate("/dashboard");
      }, 2000);
    }

    return () => {
      clearTimeout(time);
    };
  }, [changePass.isSuccess]);

  return (
    <form onSubmit={handleSubmit}>
      <AxCard
        title={
          <div className="card-title headline bold m">
            Change Password
            <AxPopover
              style={{
                width: 500,
              }}
              content={
                <div>
                  <p>One uppercase letter</p>
                  <p>One lowercase letter</p>
                  <p>One number</p>
                  <p>
                    One special character
                    <br />
                    {'(!~<>,;:_=?*+#."&%()|$^@/)'}
                  </p>
                </div>
              }
              title="Password Requirements"
            >
              <AxIconWrapper
                type="regular"
                icon={"fa-circle-info"}
              />
            </AxPopover>
          </div>
        }
        style={{ width: 400, margin: "auto" }}
        radius="medium"
        shadow="medium"
        actions={[
          <div className="btn-center">
            <RapButton
              className="button-right"
              color="main"
              styleType="primary"
              type="submit"
            >
              Submit
            </RapButton>
          </div>,
        ]}
      >
        <div className="spaced-input">
          <div className="ant-space-item">
            <RapInput
              id="currentPass"
              name="currentPass"
              type="password"
              placeholder="Current password"
              inputSize="large"
              style={{ width: `16rem` }}
            />
            {/*<AxPassword
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setCurrent(e.target.value)
                  }
                  onKeyPress={handleKeyPress}
                  prefix={<AxIconWrapper type="regular" icon={"fa-key"} />}
                  placeholder="Current Password"
                  value={current}
                  size="medium"
                />*/}
          </div>
          {/*<Error message={currentErr} />*/}
          <div className="ant-space-item">
            {/*<span className="ax-input-wrapper ax-input-default-wrapper direction-vertical">*/}
            <RapInput
              id="newPass"
              name="newPass"
              type="password"
              placeholder="New password"
              inputSize="large"
              style={{ width: `16rem` }}
            />
            {/*<AxPassword
                  onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                    setUpdated(e.target.value)
                  }
                  onKeyPress={handleKeyPress}
                  prefix={<AxIconWrapper type="regular" icon={"fa-key"} />}
                  placeholder="New Password"
                  value={updated}
                  inputSize="medium"
                />*/}
            {/*</span> */}
            {/*<div className="ant-space-item">
                <Error message={updateErr} />
              </div>*/}
          </div>
        </div>
      </AxCard>
    </form>
  );
};
